import React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { useI18n } from 'contexts/i18n'
import { useAccess } from 'contexts/access'
import { useWithinQuota } from 'hooks/within-quota'
import { format } from 'date-fns'
import { size } from 'utilities/object'
import Modal, { useModal } from 'modals/dialog'
import Loader from 'components/loader'
import {
    Wrap,
    ContactFrame, ContactFrameInner, ContactSupport
} from './s'
import { LimitStatusLabelProgress, enrichQuota } from 'pages/documents/hero/limit-status'
import Paragraph from 'components/typography/paragraph'

const SigningQuota = ({ access = 'signing' }) => {
    const { formatMessage } = useIntl()
    const { dateLocale: locale } = useI18n()

    const { dismiss } = useModal()

    const { checkFeature, check } = useAccess()
    const signingAccess = checkFeature('digital-signing') && (check('digital-signing:manage')/* || check('unit:document-signing:manage')*/)
    const billingAccess = check('organization:manage')

    const [, quota = {}] = useWithinQuota({
        prefix: 'feature',
        key: 'digital-signing',
        dependencies: [(access === 'organization') ? billingAccess : signingAccess]
    })

    if(!size(quota)) {
        return <Loader />
    }

    const {
        used,
        limit
    } = enrichQuota(quota)

    return (
        <>
            <Modal.Header heading={formatMessage({
                id: 'documents_digital_signing_heading',
                defaultMessage: 'Digital signing'
            })} />
            <Modal.Body>
                <Wrap>
                    <LimitStatusLabelProgress quota={quota} />
                    <Paragraph className="compact">
                        <FormattedMessage
                            id="documents_signing_quota_details_count"
                            defaultMessage="{remaining, plural, =0 {Impressive 💪! You’ve already sent the maximum of {limit} documents for signing. Your quota will renew {renewsAt}.} =1 {You have 1 document left to send for signing. Your quota will renew {renewsAt}.} other {You have {remaining} documents left to send for signing. Your quota will renew {renewsAt}.}}"
                            values={{
                                remaining: limit - used,
                                limit,
                                renewsAt: format(new Date(new Date().getFullYear() + 1, 0, 1), 'PPP', { locale })
                            }} />
                        <FormattedMessage
                            id="sentence_separator"
                            defaultMessage=" " />
                        <FormattedMessage
                            id={billingAccess ?
                                'subscription_addon_action_reach_out_admin_support' :
                                'subscription_addon_action_reach_out_user'
                            }
                            defaultMessage={billingAccess ?
                                'Reach out to our support team if you need more.' :
                                'Reach out to your administrator if you need more.'
                            } />
                    </Paragraph>
                    {!!billingAccess && (
                        <ContactFrame>
                            <ContactFrameInner>
                                <ContactSupport
                                    dismiss={dismiss}
                                    salt="documents:signing:quota" />
                            </ContactFrameInner>
                        </ContactFrame>
                    )}
                </Wrap>
            </Modal.Body>
        </>
    )
}

export default SigningQuota